/**
 * Wie weit ein Clip an den Anfassern wachsen darf.
 *
 * Sascha, 8. September: „wenn ich ein geschnittenes Video mit Anfasser
 * seitlich vergrößere, kann ich es über ein anderes drüber ziehen. Das ist
 * unlogisch und sollte vermieden werden.“ War es auch: beim Verschieben
 * prüfte die Zeitleiste den Platz, beim Trimmen nicht. Ein Clip, der über
 * den Nachbarn wächst, ist dann zwei Clips an einer Stelle — und wer gewinnt,
 * sagt die Reihenfolge in der Liste, nicht der Schnitt.
 *
 * Die Grenzen sind die Nachbarn auf derselben Spur: der Anfang darf bis ans
 * Ende des vorigen, das Ende bis an den Anfang des nächsten. Gibt es keinen,
 * gilt der Spuranfang bzw. gar nichts.
 */
export function trimGrenzen(clips, clipId) {
    const eigener = clips.find((c) => c.id === clipId);
    if (!eigener)
        return { fruehestens: 0, spaetestens: Number.POSITIVE_INFINITY };
    // Eine Blende ist ein gewolltes Überlappen -- genau um ihre Dauer, nicht
    // weiter. Der spätere Clip trägt sie (`transitionIn`).
    const eigeneBlende = eigener.transitionIn?.duration ?? 0;
    let fruehestens = 0;
    let spaetestens = Number.POSITIVE_INFINITY;
    for (const c of clips) {
        if (c.id === clipId)
            continue;
        if (c.start < eigener.start) {
            fruehestens = Math.max(fruehestens, c.start + c.duration - eigeneBlende);
        }
        else {
            spaetestens = Math.min(spaetestens, c.start + (c.transitionIn?.duration ?? 0));
        }
    }
    return { fruehestens, spaetestens };
}
//# sourceMappingURL=trimmen.js.map